import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {LocalCustomerSettingsModel} from '../../../../models/LocalCustomerSettingsModel';
import {LocalCustomerFilterComponent} from '../../../general-components/filter/local-customer-filter/local-customer-filter.component';
import {RegionFilterComponent} from '../../../general-components/filter/region-filter/region-filter.component';
import {BaseGeneralComponent} from '../../../BaseGeneralComponent';
import {LoaderService} from '../../../general-services/service-loader/loader.service';
import { Offset } from 'src/models/Offset';
import {LocalCustomerAnagrafService} from '../../../general-services/service-local-customer-anagraf/local-customer-anagraf.service';
import {RegionService} from '../../../general-services/service-region-anagraf/region-service.service';
import {forkJoin, Observable} from 'rxjs';

@Component({
  selector: 'app-filter-lc',
  templateUrl: './filter-lc.component.html',
  styleUrls: ['./filter-lc.component.scss']
})
export class FilterLcComponent extends BaseGeneralComponent implements OnInit, OnDestroy {

  @Input() showNewEditDelete?: boolean;
  @Input() filter: LocalCustomerSettingsModel;

  localCustomerData: any;
  regionData: any;

  @Output() dataFiltered = new EventEmitter<any>();
  @Output() resetDataFiltered = new EventEmitter<any>();

  @ViewChild(LocalCustomerFilterComponent) localCustomerFilterComponent;
  @ViewChild(RegionFilterComponent) regionFilterComponent;

  filterSingle: LocalCustomerSettingsModel;
  labelAnnoMeseRif: string;
  offset: Offset;
  dataSource: any;
  intermittentBool: boolean;

  constructor(private loaderService: LoaderService,
              private localCustomerService: LocalCustomerAnagrafService,
              private regionService: RegionService) {
    super();
    this.loaderService.display(true);
  }

  ngOnInit() {
    if (!this.filter) {
      this.filter = new LocalCustomerSettingsModel();
    }
    this.filterSingle = LocalCustomerSettingsModel.clone(this.filter);
    this.offset = new Offset(10, 0);
    this.labelAnnoMeseRif = 'Reference Month';
    if (JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.LOCAL_CUSTOMER_SETTINGS_FILTER))) {
      this.filter = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.LOCAL_CUSTOMER_SETTINGS_FILTER));
    }
    if (this.showNewEditDelete === undefined) {
      this.showNewEditDelete = true;
    }
    this.initFilter(this.filterSingle);
  }

  initFilter(allLocalCustomerSettingModel: LocalCustomerSettingsModel, isReset?: boolean) {
    const getAllRegionObservable: Observable<any> = this.regionService.getListInLocalCustomerSetting(this.filterSingle).pipe();
    const getAllLocalCustomerObservable: Observable<any> = this.localCustomerService.getListInLocalCustomerSetting(this.filterSingle).pipe();

    forkJoin([getAllRegionObservable, getAllLocalCustomerObservable])
      .subscribe(
        (resultFork: any) => {
          this.regionData = resultFork[0];
          this.localCustomerData = resultFork[1];
          if (!isReset) {
            this.loaderService.display(false);
          } else {
            this.dataFiltered.emit(this.filter);
          }
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });


  }

  interceptRegionChange(event) {
    this.loaderService.display(true);
    this.intermittentBool = true;
    this.intermittentFilterButton(this.intermittentBool);

    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.region = event;

    const getAllLocalCustomerFilteredObservable: Observable<any> = this.localCustomerService.getListInLocalCustomerSetting(this.filterSingle).pipe();

    observableList.push(getAllLocalCustomerFilteredObservable);

    forkJoin(observableList)
      .subscribe(
        (resultFork: any) => {
          this.localCustomerData = resultFork[0];
          this.filter.localCustomer = this.filterSingle.localCustomer;
          this.loaderService.display(false);
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  interceptLocalCustomerChange(event) {
    this.loaderService.display(true);
    this.intermittentBool = true;
    this.intermittentFilterButton(this.intermittentBool);

    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.localCustomer = event;

    const getAllRegionFilteredObservable: Observable<any> = this.regionService.getListInLocalCustomerSetting(this.filterSingle).pipe();

    observableList.push(getAllRegionFilteredObservable);

    forkJoin(observableList)
      .subscribe(
        (resultFork: any) => {
          this.regionData = resultFork[0];
          this.filter.region = this.filterSingle.region;
          this.loaderService.display(false);
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  filterTable(): void {
    this.loaderService.display(true);
    this.intermittentBool = false;
    this.intermittentFilterButton(this.intermittentBool);

    this.getAllFilters();

    sessionStorage.setItem(this.SESSION_STORAGE_LABELS.LOCAL_CUSTOMER_SETTINGS_FILTER, JSON.stringify(this.filter));

    this.dataFiltered.emit(this.filter);
  }

  reset() {
    this.loaderService.display(true);
    this.intermittentBool = false;
    this.intermittentFilterButton(this.intermittentBool);

    const isReset = true;
    this.filter = new LocalCustomerSettingsModel();
    this.filterSingle = new LocalCustomerSettingsModel();

    const getLocalCustomerObservable: Observable<any> = this.localCustomerService.getListInLocalCustomerSetting(this.filterSingle).pipe();
    const getRegionObservable: Observable<any> = this.regionService.getListInLocalCustomerSetting(this.filterSingle).pipe();

    forkJoin([getLocalCustomerObservable, getRegionObservable])
      .subscribe(
        (resultFork: any) => {
          this.localCustomerData = resultFork[0];
          this.regionData = resultFork[1];

          sessionStorage.setItem(this.SESSION_STORAGE_LABELS.LOCAL_CUSTOMER_SETTINGS_FILTER, JSON.stringify(this.filter));
          this.filterSingle =  new LocalCustomerSettingsModel();

          this.initFilter(this.filterSingle, isReset);
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  getAllFilters() {
    this.filter.localCustomer = this.localCustomerFilterComponent.optionSelected;
    this.filter.region = this.regionFilterComponent.optionSelected;
  }

  ngOnDestroy(): void {
  }

}

